module.exports = __webpack_public_path__ + "static/media/financecase2.386230d6.png";